import { Dispatch, SetStateAction, useEffect } from 'react'
import dayjs from 'dayjs'

type UseRetractationEffectProps = {
  startLeasingDate: string | null
  isRetractation: boolean
  retractingDays: number
  setRetractReady: Dispatch<SetStateAction<boolean>>
  setRetractAgree: Dispatch<SetStateAction<boolean>>
}

const useRetractationEffect = ({
  startLeasingDate,
  isRetractation,
  retractingDays,
  setRetractReady,
  setRetractAgree,
}: UseRetractationEffectProps) => {
  useEffect(() => {
    if (startLeasingDate && isRetractation && retractingDays) {
      // we enable another agreement if start leasing date is in 14 days.
      if (
        dayjs(dayjs(startLeasingDate, 'DD/MM/YYYY'), 'd').diff(dayjs(), 'd') <
        retractingDays
      ) {
        setRetractReady(true)
        setRetractAgree(false)
      } else {
        setRetractReady(false)
        setRetractAgree(true)
      }
    } else {
      setRetractAgree(true)
    }
  }, [
    startLeasingDate,
    isRetractation,
    retractingDays,
    setRetractReady,
    setRetractAgree,
  ])
}

export default useRetractationEffect
